import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Utilisateur } from '../models/utilisateur.model';

@Injectable({
  providedIn: 'root',
})
export class UtilisateurService {
  apiUrl = environment.apiUrl;
  response: any;
  responseCad: any;

  constructor(private http: HttpClient) {}

  query(): Observable<HttpResponse<Utilisateur[]>> {
    const params = new HttpParams().set('query', 'query');
    return this.http.get<Utilisateur[]>(`${this.apiUrl}/utilisateur`, {
      observe: 'response',
      params: params,
    });
  }

  queryAll(): Observable<HttpResponse<Utilisateur[]>> {
    const params = new HttpParams().set('query', 'queryAll');
    return this.http.get<Utilisateur[]>(`${this.apiUrl}/utilisateur`, {
      observe: 'response',
      params: params,
    });
  }
}
